__turbopack_context__.v({
  "className": "publicsans_ccf051ac-module__-ZqwOa__className",
  "variable": "publicsans_ccf051ac-module__-ZqwOa__variable",
});
